import { Box, type IColumn, Typography } from 'shared/ui'
import { type ReviewRow } from 'entities/Review'
import { RatingStars } from 'pages/reviews/pages/all/ui/RatingStars/RatingStars'

export const columns: IColumn<ReviewRow>[] = [
  {
    field: 'name',
    name: 'Name',
    isDisabledChangeVisible: true,
    isSortable: true,
    width: '100%',
    minWidth: 230,
    renderRowCell: ({ name }) => (
      <Typography variant='body-md-regular' ariaLabel='ReviewName' ellipsis>
        {name}
      </Typography>
    ),
  },
  {
    field: 'rating',
    name: 'Rating',
    minWidth: 195,
    renderRowCell: ({ rating, happyCount, unhappyCount }) => (
      <Box display={'flex'} alignItems={'center'} gap={'8px'}>
        {!!rating && (
          <Typography variant='body-md-regular' ariaLabel='ReviewRating'>
            {rating}
          </Typography>
        )}
        <RatingStars rating={rating} />
        <Typography variant='body-md-regular' ariaLabel='ReviewRatingCount' color='tertiary'>
          ({happyCount + unhappyCount})
        </Typography>
      </Box>
    ),
  },
  {
    field: 'happy_count',
    name: 'Stars (4-5)',
    minWidth: 100,
    renderRowCell: ({ happyCount }) => (
      <Typography variant='body-md-regular' ariaLabel='ReviewStarsHigh'>
        {happyCount}
      </Typography>
    ),
  },
  {
    field: 'unhappy_count',
    name: 'Stars (1-3)',
    minWidth: 100,
    renderRowCell: ({ unhappyCount }) => (
      <Typography variant='body-md-regular' ariaLabel='ReviewStarsLow'>
        {unhappyCount}
      </Typography>
    ),
  },
  {
    field: 'review_page_clicks',
    name: 'Review page clicks',
    minWidth: 140,
    renderRowCell: ({ clickCount }) => (
      <Typography variant='body-md-regular' ariaLabel='ReviewPageClicks'>
        {clickCount}
      </Typography>
    ),
  },
  {
    field: 'short_url',
    name: 'Review page link',
    disableLink: true,
    renderRowCell: ({ shortUrl }) => (
      <a href={shortUrl} target={'_blank'} rel='noreferrer' className={'noTextDecoration'}>
        <Typography variant={'body-md-regular'} link ariaLabel={'ReviewPageLink'}>
          {shortUrl}
        </Typography>
      </a>
    ),
  },
]
